/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get Insights constants

export const INSIGHTS_AP_REQUEST_GET = 'INSIGHTS_AP_REQUEST_GET';
export const INSIGHTS_AP_RESPONSE_GET_SUCCESS =
	'INSIGHTS_AP_RESPONSE_GET_SUCCESS';
export const INSIGHTS_AP_RESPONSE_GET_FAIL = 'INSIGHTS_AP_RESPONSE_GET_FAIL';

export const DOWNLOAD_INSIGHTS_AP_REQUEST_GET =
	'DOWNLOAD_INSIGHTS_AP_REQUEST_GET';
export const DOWNLOAD_INSIGHTS_AP_RESPONSE_GET_SUCCESS =
	'DOWNLOAD_INSIGHTS_AP_RESPONSE_GET_SUCCESS';
export const DOWNLOAD_INSIGHTS_AP_RESPONSE_GET_FAIL =
	'DOWNLOAD_INSIGHTS_AP_RESPONSE_GET_FAIL';

export const INSIGHTS_CLIENT_REQUEST_GET = 'INSIGHTS_CLIENT_REQUEST_GET';
export const INSIGHTS_CLIENT_REQUEST_GET_SUCCESS =
	'INSIGHTS_CLIENT_REQUEST_GET_SUCCESS';
export const INSIGHTS_CLIENT_REQUEST_GET_FAIL =
	'INSIGHTS_CLIENT_REQUEST_GET_FAIL';

export const DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET =
	'DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET';
export const DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET_SUCCESS =
	'DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET_SUCCESS';
export const DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET_FAIL =
	'DOWNLOAD_INSIGHTS_CLIENT_REQUEST_GET_FAIL';
